<div
  [style.height.px]="size()"
  [style.width.px]="size()"
  class="flex items-center justify-center overflow-hidden rounded-full bg-primary text-white"
>
  @let _user = user();
  @if (overrideUrl() || (_user && _user.avatar)) {
    <img
      class="h-full w-full object-cover"
      [src]="overrideUrl() && (user()?.avatar ?? '')"
      [alt]="'common.avatar' | translate"
      [height]="size()"
      [width]="size()"
      onerror="this.src = 'https://placeholder.com/60'"
    />
  } @else {
    {{ avatarFallback() | uppercase }}
  }
</div>
